import React, { useEffect, useState, useRef } from "react";
import {
  Space,
  Button,
  Table,
  Radio,
  Form,
  Spin,
  Modal,
  message,
  Image,
} from "antd";
import axios from "axios";
import API from "@/api";
import SqFormDetail from "../sqFormDetail";
import ModelDetail from "../modelDetail";
import Gllp from "../gllp";

function Mxsq(props) {
  const { types, tokens, models, userInfo } = props;
  const [type, setType] = useState("all");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [spinning, setSpinning] = useState(true);
  const [open, setOpen] = useState(false);
  const sqFormDetailRef = useRef();
  const [dtype, setDtype] = useState("add");
  const [id, setId] = useState("");
  const [refresh, setRefresh] = useState("");
  const [modelOpen, setModelOpen] = useState(false);
  const [gllpOpen, setGllpOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.all([getMyApplyModelList()]).then(
      axios.spread((res) => {
        const data = res?.data?.result?.data;
        setData(data);
        setLoading(false);
        setSpinning(false);
      })
    );
  }, [type, refresh]);

  const getMyApplyModelList = () => {
    return axios.get(
      API.getMyApplyModelList + `?category=${type === "all" ? "" : type}`
    );
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div>
          <Form
            initialValues={{
              type: type,
            }}
          >
            <Form.Item label="类型" name="type">
              <Radio.Group
                options={types}
                value={type}
                onChange={(val) => {
                  setType(val?.target?.value);
                }}
              />
            </Form.Item>
          </Form>
        </div>
        <div
          style={{
            paddingBottom: "24px",
          }}
        >
          <Space>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              申请模型
            </Button>
          </Space>
        </div>
        <Spin spinning={spinning}>
          <Table
            bordered
            dataSource={data}
            columns={[
              {
                title: "图标",
                dataIndex: "iconUrl",
                render(val) {
                  return <Image width={30} height={30} src={val} alt=" " />;
                },
                width:60,
                fixed:"left"
              },
              {
                title: "模型ID",
                dataIndex: "modelId",
                width:120
              },
              {
                title: "模型名称",
                dataIndex: "name",
              },
              {
                title: "模型类型",
                dataIndex: "categoryName",
                width:120
              },
              {
                title: "参数规模",
                dataIndex: "paramSize",
                width:100
              },
              {
                title: "上下文长度",
                dataIndex: "context",
                width:100
              },
              {
                title: "分类",
                dataIndex: "deploymentTypeLabel",
                width:100
              },
              {
                title: "关联令牌",
                dataIndex: "tokenList",
                width:200,
                render(val) {
                  const arr = [];
                  if (val && val.length) {
                    val.map((item) => {
                      arr.push(item.name);
                    });
                  }
                  return arr && arr.length ? arr.join(",") : "";
                },
              },
              {
                title: "操作",
                dataIndex: "modelId",
                align: "center",
                width: 200,
                render(val, row) {
                  return (
                    <Space>
                      <span
                        style={{
                          color: "#1890FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setId(row?.id);
                          setModelOpen(true);
                        }}
                      >
                        查看
                      </span>
                      <span
                        style={{
                          color: "#1890FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setGllpOpen(true);
                          setId(row?.modelId);
                        }}
                      >
                        关联令牌
                      </span>
                      <span
                        style={{
                          color: "#1890FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          Modal.confirm({
                            title: "取消",
                            content: "确定取消申请，确定后需重新申请",
                            okText: "确定",
                            cancelText: "取消",
                            onOk() {
                              axios
                                .post(API.deleteModel, { modelId: val })
                                .then((res) => {
                                  if (res?.data?.resultCode === 0) {
                                    message.success("删除成功");
                                    setRefresh(Math.random());
                                  } else {
                                    message.error(res?.data?.errorMsg);
                                  }
                                });
                            },
                          });
                        }}
                      >
                        删除
                      </span>
                    </Space>
                  );
                },
              },
            ]}
            loading={loading}
            scroll={{
              x:1200
            }}
          />
        </Spin>
        <Modal
          title="申请模型"
          open={open}
          destroyOnHidden={true}
          onCancel={() => {
            setOpen(false);
          }}
          onOk={() => {
            const data = sqFormDetailRef?.current.getValue();
            const verify = sqFormDetailRef?.current.verify();
            console.log(verify);
            verify
              .then(() => {
                for (const key in data) {
                  if (data[key]) {
                    data[key] = data[key];
                  } else {
                    data[key] = "";
                  }
                }
                axios.post(API.applyModel, data).then((res) => {
                  if (res?.data?.resultCode === 0) {
                    message.success("申请成功");
                    setOpen(false);
                    setRefresh(Math.random());
                  } else {
                    message.error(res?.data?.errorMsg);
                  }
                });
              })
              .catch(() => {});
          }}
          width={"800px"}
          okText="确定"
          cancelText="取消"
        >
          <SqFormDetail
            ref={sqFormDetailRef}
            models={models}
            tokens={tokens}
            userInfo={userInfo}
            id={id}
            type={dtype}
          />
        </Modal>
        <Modal
          title="模型详情"
          width={"800px"}
          open={modelOpen}
          destroyOnHidden
          onCancel={() => {
            setModelOpen(false);
            setRefresh(Math.random());
            setId("");
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setModelOpen(false);
                  setRefresh(Math.random());
                }}
              >
                关闭
              </Button>
            </>
          }
        >
          <ModelDetail id={id} />
        </Modal>
        <Modal
          title="关联令牌"
          open={gllpOpen}
          destroyOnHidden
          onCancel={() => {
            setGllpOpen(false);
            setRefresh(Math.random());
            setId("");
          }}
          width={"900px"}
          footer={
            <>
              <Button
                onClick={() => {
                  setGllpOpen(false);
                  setRefresh(Math.random());
                  setId("");
                }}
              >
                关闭
              </Button>
            </>
          }
        >
          <Gllp id={id} />
        </Modal>
      </div>
    </>
  );
}

export default Mxsq;
